import type { ReactNode } from 'react';

import { useAppSelector } from '@/context/store/hooks';
import type { AuthUser } from '@/context/store/slices/authSlice';

type Role = AuthUser['role'];

type Props = {
  roles: Role[];
  children: ReactNode;
  fallback?: ReactNode;
};

export function RoleGate({ roles, children, fallback = null }: Props) {
  const userRole = useAppSelector((s) => s.auth.user?.role);
  if (!userRole || !roles.includes(userRole)) return <>{fallback}</>;
  return <>{children}</>;
}
